var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74.97 61.45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.05 32.57h34.04v2h-34.04z",
    transform: "matrix(.83340385 -.55266448 .55266448 .83340385 -15.71 15.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.89 16.55h2v34.04h-2z",
    transform: "matrix(.55 -.83 .83 .55 -2.08 63.27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 44.72v-7.12l32.51-21.55v23.28zm2.5-5.72v2.82l27.5-4.61v-16.51z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m75 44.72-32.54-5.39v-23.28l32.54 21.55zm-30-7.51 27.51 4.56v-2.77l-27.51-18.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.43 61.33 14.05-1.96-5.37-7.16-9.81 7.19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m51.53 61.33-14.05-1.96 5.37-7.16 9.82 7.19z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m37.48 61.45-7.48-9.96v-41.26a10.75 10.75 0 0 1 7-10.07l.48-.16.43.16a10.75 10.75 0 0 1 7.09 10.07v41.26zm-5-10.79 5 6.63 5-6.63v-40.43a8.24 8.24 0 0 0 -5-7.55 8.25 8.25 0 0 0 -5 7.55z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m43.71 15a9.23 9.23 0 0 0 -12.45 0v-2.74a9.23 9.23 0 0 1 12.45 0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlane);
export default __webpack_public_path__ + "static/media/icon_plane.6d12daadfb141b62213a03b4b3a501c7.svg";
export { ForwardRef as ReactComponent };